module.exports = __webpack_public_path__ + "static/media/v48.ebe2b60a.mp4";